"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_UPDATE_COMPANY_STORE = void 0;
var client_1 = require("@apollo/client");
var fragments_1 = require("../fragments");
exports.APP_UPDATE_COMPANY_STORE = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation AppUpdateCompanyStore($input: UpdateCompanyStoreInput!) {\n    updateCompanyStore(input: $input) {\n      store {\n        ...FullStore\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation AppUpdateCompanyStore($input: UpdateCompanyStoreInput!) {\n    updateCompanyStore(input: $input) {\n      store {\n        ...FullStore\n      }\n    }\n  }\n  ", "\n"])), fragments_1.FULL_STORE_FRAGMENT);
var templateObject_1;
